import React, { useState } from "react"
import { bool, func, string } from "prop-types"
import styled from "styled-components"
import { graphql, useStaticQuery } from "gatsby"
import { Icon } from "../Icon"
import { FlexSearchResults } from "./FlexSearchResults"

const PageHeaderSearchInputRoot = styled.div`
  height: 38px;
  position: relative;
  z-index: 99;
`

const PageHeaderSearchInputRootCloseOutside = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 98;
`

const SearchInput = styled.input`
  width: 100%;
  height: 38px;
  padding: 6px 6px 6px 30px;

  @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
    width: 300px;
  }
`

const IconWrapper = styled.div`
  position: absolute;
  top: 9px;
  left: 6px;
`

const query = graphql`
  query PageHeaderSearchInput {
    localSearchSearch {
      publicIndexURL
      publicStoreURL
    }
  }
`

export const FlexSearchInput = props => {
  const [searchIndex, setSearchIndex] = useState(null)
  const [searchStore, setSearchStore] = useState(null)
  const { input, onChange, floatingResults } = props

  const data = useStaticQuery(query)

  const { publicIndexURL, publicStoreURL } = data.localSearchSearch

  const getDataByFocusedInput = async () => {
    if (!searchIndex || !searchStore) {
      const index = await fetch(publicIndexURL)
        .then(response => response.json())
        .then(data => JSON.stringify(data))

      const store = await fetch(publicStoreURL).then(response =>
        response.json()
      )

      setSearchIndex(index)
      setSearchStore(store)
    }
  }

  return (
    <>
      <PageHeaderSearchInputRoot>
        <IconWrapper>
          <Icon type="SEARCH_ICON" fill="black" width="20" height="20" />
        </IconWrapper>
        <SearchInput
          type="text"
          icon="search"
          value={input}
          onFocus={getDataByFocusedInput}
          onChange={e => onChange(e.target.value)}
          placeholder="Search…"
        />
        {input !== "" && searchIndex && searchStore && (
          <FlexSearchResults
            input={input}
            searchIndex={searchIndex}
            searchStore={searchStore}
            floatingResults={floatingResults}
          />
        )}
      </PageHeaderSearchInputRoot>
      {floatingResults && input !== "" && (
        <PageHeaderSearchInputRootCloseOutside onClick={() => onChange("")} />
      )}
    </>
  )
}

FlexSearchInput.defaultProps = {
  floatingResults: false,
}

FlexSearchInput.propTypes = {
  input: string.isRequired,
  onChange: func.isRequired,
  floatingResults: bool,
}
